import React from 'react';

interface MockReservationFormProps {
  mode?: 'create' | 'edit';
  isAllDay?: boolean;
}

const MockReservationForm: React.FC<MockReservationFormProps> = ({
  mode = 'create',
  isAllDay = false
}) => {
  return (
    <div className="p-4 bg-white">
      <h2 className="text-lg font-bold text-slate-800 mb-1">
        {mode === 'create' ? 'Create Reservation' : 'Edit Reservation'}
      </h2>
      <p className="text-sm text-blue-600 mb-4">Wednesday, January 15, 2025</p>

      <div className="space-y-3">
        {/* Title */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Title *
          </label>
          <input
            type="text"
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-gray-50"
            placeholder="Reservation title"
            defaultValue={mode === 'edit' ? 'Team Meeting' : ''}
            readOnly
          />
        </div>

        {/* Description */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Description
          </label>
          <textarea
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-gray-50 resize-none"
            rows={2}
            placeholder="Optional description"
            defaultValue={mode === 'edit' ? 'Weekly team sync meeting' : ''}
            readOnly
          />
        </div>

        {/* All Day Checkbox */}
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            className="w-4 h-4 text-blue-600 rounded border-gray-300"
            checked={isAllDay}
            readOnly
          />
          <label className="text-sm text-gray-700">All Day Event</label>
        </div>

        {/* Conditional fields based on All Day */}
        {isAllDay ? (
          // All Day: Show End Date (optional)
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              End Date (Optional - for multi-day events)
            </label>
            <input
              type="date"
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-gray-50"
              defaultValue=""
              readOnly
            />
            <p className="text-[10px] text-gray-500 mt-1">
              Leave empty for single-day event
            </p>
          </div>
        ) : (
          // Timed: Show Date and Time fields
          <>
            {/* Start and End Dates */}
            <div className="grid grid-cols-2 gap-2">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Start Date *
                </label>
                <input
                  type="date"
                  className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded-lg bg-gray-50"
                  defaultValue="2025-01-15"
                  readOnly
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  End Date *
                </label>
                <input
                  type="date"
                  className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded-lg bg-gray-50"
                  defaultValue="2025-01-15"
                  readOnly
                />
              </div>
            </div>

            {/* Start and End Times */}
            <div className="grid grid-cols-2 gap-2">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Start Time *
                </label>
                <input
                  type="time"
                  className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded-lg bg-gray-50"
                  defaultValue="14:00"
                  readOnly
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  End Time *
                </label>
                <input
                  type="time"
                  className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded-lg bg-gray-50"
                  defaultValue="15:00"
                  readOnly
                />
              </div>
            </div>
          </>
        )}

        {/* Buttons */}
        <div className="flex gap-2 pt-2">
          <button className="flex-1 px-3 py-2 text-sm border border-gray-300 text-gray-700 rounded-lg">
            Cancel
          </button>
          <button className="flex-1 px-3 py-2 text-sm bg-blue-600 text-white rounded-lg">
            {mode === 'create' ? 'Create' : 'Update'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MockReservationForm;
